// Cap an over-long player nick for display. Steam persona names go up to 32 chars;
// we render at most NICK_MAX_LEN + "…". The full nick should stay in a `title` attr so
// hovering still reveals it. This is a hard safeguard on top of CSS ellipsis.

export const NICK_MAX_LEN = 28;

export const truncateNick = (name: string, max: number = NICK_MAX_LEN): string =>
  name.length > max ? `${name.slice(0, max)}…` : name;
